<template lang="pug">
#LoginPage
    loadingOverlay(v-show='loading' message='Loading . . .' :zIndex='999')
    #login-gpt(:style="loginBgStyle")
        .login-page-gpt.pt-5.pt-md-1()
            v-container.fluid.pa-0.hidden-sm-and-down(style="margin-top:80px;")
                v-row.no-gutters.d-flex.justify-center
                    v-col(cols="5" class="bg-panel")
                        img.logo.mx-auto.d-block(:src="brandSetting.logo_image_url || require('@/assets/images/UPGPT.png')" alt="UpGPT")
                        .welcome-text
                            h2(:style="titleStyle") {{brandSetting.title_text || $t('UPGPT_LOGIN.TITLE')}}
                            p.tagline(:style="subtitleStyle")
                                template(v-if="brandSetting.subtitle_text") {{brandSetting.subtitle_text}}
                                template(v-else)
                                    | {{$t('UPGPT_LOGIN.SUBTITLE_1')}}
                                    br
                                    | {{$t('UPGPT_LOGIN.SUBTITLE_2')}}
                    //- 右側表單
                    v-col(cols="7" class="form-panel")
                        v-card.flat.login-card(style="border-radius:15px!important;")
                            v-card-text
                                p.primary-login.text-center {{$t('LOGIN.LOGIN')}}
                                form
                                    v-text-field.text-input.mb-3(
                                        v-model="username"
                                        :label="$t('LOGIN.ACCOUNT')"
                                        prepend-inner-icon="mdi-account"
                                    )
                                    v-text-field.text-input.mb-3(
                                        v-model="password"
                                        :type="showPassword ? 'text' : 'password'"
                                        :label="$t('LOGIN.PWD')"
                                        prepend-inner-icon="mdi-lock"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="togglePassword"
                                    )
                                    v-text-field.text-input.mb-2(
                                        :class='displayNone ? "d-none" : ""'
                                        v-model="tenant"
                                        :label="$t('LOGIN.TENANT')"
                                        prepend-inner-icon="mdi-domain"
                                    )
                                    .text-right(style="margin-bottom:100px;")
                                        a.forget(@click='onForgetPasswordClick') {{$t('FORGET_PASSWORD.TITLE')}}
                                    input.btn.primary-btn.w-100.py-3(type="submit", :value=`$t('LOGIN.LOGIN_UPGPT')` :style="btnStyle" @click='handleLogin($event)')
            //- 手機板
            v-container.fluid.pa-0.hidden-md-and-up
                v-row.d-flex.flex-row-reverse.mt-4(v-if="showUpsideAction")
                    v-btn.px-3.pb-2(icon small)
                        v-icon(color="#abaaaa" size="18") mdi-close
                    v-btn.px-3.pb-2.mr-2(icon small)
                        v-icon(color="#abaaaa" size="18") mdi-minus
                    //- v-btn.px-4.pb-2.mr-1(icon small)
                    //-     v-icon(color="#abaaaa" size="18") mdi-logout
                v-row.no-gutters.justify-center
                    v-col(cols="12" class="form-panel-mobile")
                        img.logo-mobile(:src="brandSetting.logo_image_url || require('@/assets/images/UPGPT.png')" alt="UpGPT")
                        v-card.flat.rounded-lg.login-card-mobile(style="border-radius:15px!important;")
                            v-card-text.pa-0
                                div(v-if="showRefresh" style="height: 200px;")
                                    p.primary-mobile-login.text-center(style="height: 30px;") &nbsp;
                                    p.refresh-hint.text-center(style="margin: 0;") {{$t('LOGIN.HINT_1')}}
                                    p.refresh-hint.text-center(style="margin: 0;") {{$t('LOGIN.HINT_2')}}
                                    input.btn.refresh-btn.w-100.mt-10(:value=`$t('LOGIN.REFRESH')` type="button", @click='reloadIframe()')
                                div(v-else)
                                    p.primary-mobile-login.text-center {{ showSsoPage ? $t('LOGIN.MICROSOFT_LOGIN_TITLE') : $t('LOGIN.LOGIN') }}
                                    form                              
                                        div(style="height: 200px;")
                                            v-text-field.text-input.mb-3(
                                                v-if="!showSsoPage",
                                                v-model="username"
                                                :label="$t('LOGIN.ACCOUNT')"
                                                prepend-inner-icon="mdi-account"
                                            )
                                            v-text-field.text-input.mb-3(
                                                v-if="!showSsoPage",
                                                v-model="password"
                                                :type="showPassword ? 'text' : 'password'"
                                                :label="$t('LOGIN.PWD')"
                                                prepend-inner-icon="mdi-lock"
                                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                @click:append="togglePassword"                                   
                                            )
                                            v-text-field.text-input.mb-2(
                                                :class='displayNone ? "d-none" : ""'
                                                v-model="tenant"
                                                :label="$t('LOGIN.TENANT')"
                                                prepend-inner-icon="mdi-domain"
                                            )
                                            .text-right
                                                p.forget(v-if="!showSsoPage", @click='onForgetPasswordClick') {{$t('FORGET_PASSWORD.TITLE')}}
                                        input.btn.primary-btn.w-100.py-3(type="submit", :value=`$t('LOGIN.LOGIN_UPGPT')` :style="btnStyle" @click='showSsoPage ? handleSsoLogin($event) : handleLogin($event)')
                                        hr.my-3
                                        input.btn.outline-btn.w-100.py-3(v-if="!showSsoPage", type="button", :value=`$t('LOGIN.MICROSOFT')` @click='showSsoLogin()')
                                        input.btn.outline-btn.w-100.py-3(v-if="showSsoPage", type="button", :value=`$t('LOGIN.BACK_TO_LOGIN')` @click='hideSsoLogin()')
        footer.footer
            nav.py-md-2.py-5.text-center
                p.d-inline ART Solutions All Rights Reserved.
                span.mx-2 | 
                a.text-decoration-underline(href="/docs/DPF.pdf" target="_blank") Data Processing Agreement
    v-dialog(v-model='forgetPassword' max-width='500')
        forgetPassword-dialog(@emitForgetPasswordDialog='onEmitForgetPasswordDialog' @emitForgetPasswordSuccess='onEmitForgetPasswordSuccess')
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog()')
        success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog')
        error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog')
        message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
</template>
<script>
import { mapActions } from 'vuex';
import LoginValidationService from '@/services/LoginValidationService';
import AirgappedService from '@/services/AirgappedService';
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import messageDialog from "@/components/Dialog/messageDialog";
import loadingOverlay from "@/components/Common/loadingOverlay";
import forgetPasswordDialog from "@/components/Dialog/User/forgetPasswordDialog";
import passData from "@/services/passData.js";
import i18n from '/common/plugins/vue-i18n.js'
    export default {
        name: "UpGPT-Login",
        components: {
            errorDialog,
            successDialog,
            messageDialog,
            loadingOverlay,
            forgetPasswordDialog,
            passData
        },
        data() {
            return{
                showRefresh: false,
                showSsoPage: false,
                loading: false,
                tenant: '',
                brandSetting: {},
                username: '',
                password: '',
                loginValiCode: '',
                showPassword: false,
                forgetPassword: false,
                noneusername:false,
                nonetenant:false,
                successDialog: false,
                errorDialog: false,
                errorMessage: '',
                messageDialog: false,
                message: '',
                displayNone: false,
                displayLoginVali: false,
                changePassword:false,
                nextPath: '/upgpt',
                showUpsideAction: false,
                airgapped: false,
            }
        },
        computed: {
            loginBgStyle() {
                return this.brandSetting.bg_image_url
                    ? { backgroundImage: `url('${this.brandSetting.bg_image_url}')` }
                    : {};
            },
            titleStyle() {
                return this.brandSetting.title_color ? { color: this.brandSetting.title_color } : {};
            },
            subtitleStyle() {
                return this.brandSetting.subtitle_color ? { color: this.brandSetting.subtitle_color } : {};
            },
            btnStyle() {
                const s = {};
                if (this.brandSetting.button_color) s.backgroundColor = this.brandSetting.button_color;
                if (this.brandSetting.button_text_color) s.color = this.brandSetting.button_text_color;
                return s;
            },
        },
        mounted() {
            this.updateAfterLoginNextPath();
        },
        created() {
            if (window.self !== window.top) this.showUpsideAction = true;
            window.addEventListener('keyup', this.close)

            let nowPath = this.$router.currentRoute.fullPath;
            let test = 'upgpt-login?tenant=';
            let nullTenant = 'tenant=null';
            if(nowPath.includes(test) && !nowPath.includes(nullTenant)){
                let query_params = nowPath.slice(nowPath.indexOf(test) + test.length);
                if(query_params.includes('&'))
                    this.tenant = query_params.split('&')[0];
                else
                    this.tenant = query_params;
                this.displayNone = true;
            }
            const tenantForBrand = this.tenant || (this.$route.query && this.$route.query.tenant) || '';
            if (tenantForBrand && tenantForBrand !== 'null') {
                // 品牌設定與 airgapped 旗標同一個端點，loadBrandSetting 會一併帶回
                this.loadBrandSetting(tenantForBrand);
            } else {
                // 裸網址（tenant 未知）：旗標不需要 tenant，仍查得到
                this.resolveAirgapped();
            }

            let userdata = JSON.parse(window.localStorage.getItem('userData'));
            let user = JSON.parse(window.localStorage.getItem('user'));
            if(user == null && userdata != null){
                user = userdata;
            }
            if(user != null)
            {
                let is_portal_user = user['is_portal_user'] || false;
                this.changePassword = user.change_password;
                if(this.changePassword){
                    if(window.location.href.includes('next=') && window.location.href.includes('UpGPT_Portal') && is_portal_user){
                        this.$router.replace('/UpGPT_Portal');    
                    }else if(window.location.href.includes('next=') && window.location.href.includes('UpGPT_Portal') && !is_portal_user){
                        this.$router.replace('/upgpt/PermissionErrorPortal'); 
                    }else{
                        this.$router.replace('/upgpt/UserSetting/');                    
                    }
                }
                else{
                    let nextToPath = this.nextPath;
                    if (window.location.href.includes('next=')) {
                        let urlNext = decodeURIComponent(window.location.href.split('next=')[1]);
                        nextToPath = urlNext;
                    }
                    this.$router.replace(nextToPath);
                }
            }else{
                this.reloadIframe()
            }
        },
        methods: {
            async loadBrandSetting(tenant) {
                try {
                    const res = await LoginValidationService.loginBrandingSetting(tenant);
                    if (res.data && typeof res.data === 'object') {
                        this.brandSetting = res.data;
                        // 同一個端點也帶回部署層級的 airgapped 旗標，不必再查一次
                        this.airgapped = res.data.airgapped === true;
                    }
                } catch (e) {
                    // silently fail, use default styles
                    // 品牌設定失敗不代表旗標查不到，補查一次
                    this.resolveAirgapped();
                }
            },
            async resolveAirgapped() {
                const value = await AirgappedService.resolveAirgapped();
                // null 代表查不到，維持 false 走既有流程，由後端保底接住
                if (value !== null) this.airgapped = value;
            },
            onForgetPasswordClick() {
                // 地端沒有 email 這條路，一律導向管理員，不進入現行重設流程
                if (this.airgapped) {
                    this.errorMessage = i18n.t('FORGET_PASSWORD.AIRGAPPED');
                    this.errorDialog = true;
                    return;
                }
                this.forgetPassword = true;
            },
            ...mapActions([
                'loginSsoUpGptUser', 'loginUpGptUser',
            ]),
            getCookieValue(name) {
                const cookies = document.cookie.split('; '); // 先拆成每個 key=value
                for (let cookie of cookies) {
                    const [key, value] = cookie.split('='); // 拆 key 和 value
                    if (key === name){
                    return name === 'user' ? decodeURIComponent(value) : value;
                    }
                }
                return null;
            },
            syncCookieToLocalStorage() {
                const keys = [
                    'access_token',
                    'refresh_token',
                    'id_token',
                    'tenant',
                    'isUpchatUser',
                    'isUpGPTUser',
                    'upchat_login',
                    'user',
                    'language',
                    'location',
                    'is_staff',
                    'fcm_token',
                    'sso',
                    'lastActive',
                    'idleTimeLimit'
                ];

                keys.forEach(key => {
                    const cookieVal = this.getCookieValue(key);
                    const localVal = window.localStorage.getItem(key);

                    if (cookieVal && !localVal) {
                        window.localStorage.setItem(key, cookieVal);
                    }
                });
            },
            checkCookieForUpSide() {
                this.syncCookieToLocalStorage();
                const checkCopiedCookies = [
                    "access_token",
                    "refresh_token",
                    "tenant",
                    "isUpchatUser",
                    "isUpGPTUser",
                    "upchat_login",
                    "user",
                    "language",
                    "location",
                    "is_staff",
                    "fcm_token",
                    "sso",
                ];
                const allExist = checkCopiedCookies.every(key => localStorage.getItem(key) !== null);
                return allExist
            },
            reloadIframe() {
                let allExist = this.checkCookieForUpSide();
                if (allExist) {
                    let jot_time = 15000;
                    var user = JSON.parse(window.localStorage.getItem('user'));
                    this.changePassword = user.change_password;
                    let max_chat = 10;
                    let max_mail = 5;
                    let tenant = this.tenant.toLowerCase();
                    parent.postMessage({
                        isUpday:true,
                        from: "UpSide_After_Login",
                        type:"has_login",
                        value: [jot_time,user,max_chat,max_mail,tenant]
                    }, "*")
                    window.location.reload();
                } else {
                    console.log("localStorage 缺少 key，iframe 不刷新");
                }
            },
            showSsoLogin() {
                this.showSsoPage = true;
                this.tenant = '';
            },
            hideSsoLogin() {
                this.showSsoPage = false;
                this.tenant = '';
            },
            handleSsoLogin(event) {
                event.preventDefault();
                if (this.tenant == '')
                {
                    this.errorDialog = true;
                    this.errorMessage = i18n.t('LOGIN.ERROR_2');
                }
                else
                {
                    let tenant = this.tenant.toLowerCase();
                    this.loading = true;
                    this.loginSsoUpGptUser({ tenant: tenant, loginValiCode: this.loginValiCode, needRedirect: false })
                    .then((redirectPath) => {
                        this.loading = false;
                        this.$emit('loginSuccess');
                        this.showRefresh = true;
                        window.open(redirectPath, '_blank');
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.errorDialog = true;
                        if(error.response){
                            this.errorMessage = i18n.t('LOGIN.ERROR_3');
                        } else if (typeof error === 'string' && error === 'Incorrect login information') {
                            this.errorMessage = i18n.t('LOGIN.ERROR_5');
                        }
                    })
                    .finally(() => {
                        passData.$emit("status");
                        passData.$emit("upchat",window.localStorage.getItem('isUpchatUser'));
                    })
                }
            },
            togglePassword() {
                this.showPassword = !this.showPassword
            },
            onEmitForgetPasswordDialog(val) {
                this.forgetPassword = val;
            },
            onEmitForgetPasswordSuccess(val,errorMsg) {
                if(val){
                    this.forgetPassword = false;
                    this.successDialog = true;
                }else{
                    this.errorDialog = true;
                    this.errorMessage = errorMsg;
                }
            },
            updateAfterLoginNextPath() {
                if ('next' in this.$route.query) {
                    this.nextPath = this.$route.query.next;  
                }  
            },
            onEmitSuccessDialog() {
                this.successDialog = false;
            },
            onEmitErrorDialog(val) {
                if(val){
                    this.errorDialog = false;
                }
            },
            handleLogin(event) {
                event.preventDefault();
                if (this.tenant == ''|this.username == ''|this.password == '')
                {
                    this.errorDialog = true;
                    if(this.username == ''|this.password == '')
                    {
                        this.errorMessage = i18n.t('LOGIN.ERROR');
                        this.noneusername = true
                    }else
                    {
                        this.errorMessage = i18n.t('LOGIN.ERROR_2');
                    }
                }
                else
                {
                    let tenant = this.tenant.toLowerCase();
                    this.loading = true;
                    this.loginUpGptUser({ username: this.username, password: this.password, tenant: tenant, loginValiCode: this.loginValiCode })
                    .then(() => {
                        this.loading = false;
                        this.$emit('loginSuccess');
                        var user = JSON.parse(window.localStorage.getItem('user'));
                        this.changePassword = user.change_password;

                        let jot_time = 15000;
                        let max_chat = 10;
                        let max_mail = 5;
                        parent.postMessage({
                            isUpday:true,
                            from: "UpSide_After_Login",
                            type:"has_login",
                            value: [jot_time,user,max_chat,max_mail,tenant]
                        }, "*")
                        
                        if (window.location.href.includes('next=') && window.location.href.includes('upgpt_portal')){
                            this.forwardToUpGPTPage();   
                        }
                        else if(user.upchat_sso_link != '')
                        {
                            window.location.href = user.upchat_sso_link;
                        }
                        else
                        {
                            this.forwardToUpGPTPage();
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.errorDialog = true;
                        console.log("TEST", error)
                        if(error.response){
                            this.errorMessage = i18n.t('LOGIN.ERROR_3');
                        }
                    })
                    .finally(() => {
                        passData.$emit("status");
                        passData.$emit("upchat",window.localStorage.getItem('isUpchatUser'));
                        if(!this.errorDialog){
                            location.reload();
                        }
                    })
                }
            },
            forwardToUpGPTPage(){
                if(this.changePassword)
                {
                    let user = JSON.parse(window.localStorage.getItem('user'));
                    if(user != null){
                        let is_portal_user = user['is_portal_user'] || false;
                        if(window.location.href.includes('next=') && (window.location.href.includes('UpGPT_Portal') || window.location.href.includes('upgpt_portal')) && is_portal_user){
                            this.$router.replace('/UpGPT_Portal');    
                        }else if(window.location.href.includes('next=') && (window.location.href.includes('UpGPT_Portal') || window.location.href.includes('upgpt_portal')) && !is_portal_user){
                            this.$router.replace('/upgpt/PermissionErrorPortal'); 
                        }else{
                            this.$router.replace('/upgpt/UserSetting/')
                        }
                    }
                }
                else
                {
                    let nextToPath = this.nextPath;
                    if (window.location.href.includes('next=')){
                        let urlNext = decodeURIComponent(window.location.href.split('next=')[1]);
                        nextToPath = urlNext;
                    }
                    if(window.location.href.includes('next=') && window.location.href.includes('upgpt_portal')){
                        nextToPath = '/UpGPT_Portal'
                    }
                    this.$router.replace(nextToPath);
                }
            },
            onEmitMessageDialog(val) {
                this.messageDialog = false;
                console.log('onEmitMessageDialog: ' + val);
            },
            close(ev){
                if(this.errorDialog && ev.key == "Enter")
                {
                    if((this.tenant != ''&& !this.noneusername) | this.nonetenant )
                    {
                        this.errorDialog = false
                        this.nonetenant = false
                    }else
                    {
                        this.nonetenant = true
                    }
                }   
            },
        }
    }
</script>

<style lang="scss" scoped>
    #login-gpt{
        background-image: url("~@/assets/images/bg-upgpt-login.jpg");
        background-size: cover;
        background-position: top;
        background-repeat: no-repeat;
        min-height: 100dvh;
        height: 100dvh;
    }
    .login-page-gpt {
        // padding-top: 100px;
        position: relative;
    }
    .primary-login{
        font-size: 36px;
        font-weight: 500;
        color: #222;
    }
    .bg-panel {
        position: relative;
        padding: 64px;
        .logo {
          width: 300px;
          margin-top: 40px;
          margin-bottom: 60px;
        }
        .welcome-text{
            color: #044958;
            text-align: center;
            h2 {
                font-size: 36px;
                margin-bottom: 36px;
            }
            .tagline {
                font-size: 28px;
                color: #1095AF;
                line-height: 1.5;
                font-weight: 500;
                
            }
        }
        .v-card{
            border-radius: 15px !important;
        }
    }
    .primary-mobile-login{
        font-size: 28px;
        font-weight: 500;
        color: #222;
    }
    .refresh-hint{
        font-size: 14px;
        color: #000000
    }
    .form-panel,
    .form-panel-mobile {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 32px;

        .login-card,
        .login-card-mobile{
            width: 90%;
            max-width: 500px;
            padding: 24px;
            border-radius: 15px !important;
        }
        .logo-mobile {
            width: 160px;
            margin: 25px auto 32px;
        }
        .forget {
            font-size: 0.875rem;
            color: #00acc1;
            text-decoration: none;
        }
        .v-card__text{
            line-height: unset;
        }
    }
    .footer {
        position: absolute;
        bottom: 0px;
        width: 100%;
        color: #546e7a;
        font-size: 0.75rem;
        background-color: rgba(255, 255, 255, 0.4);
        nav a {
            color: inherit;
            text-decoration: none;
        }
        nav span {
            color: #b0bec5;
        }
    }
    .theme--light.v-sheet{
        background-color: rgba(255, 255, 255, 0.2) !important;

        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(8.8px);
        -webkit-backdrop-filter: blur(8.8px);
        border: 1.5px solid rgba(255, 255, 255, 0.3);
    }
    .theme--light.v-input input,.theme--light.v-input textarea{
        font-size: small;
    }
    .primary-btn{
        color: white;
        background-color: #14C6DE;
        border-radius: 50px;
    }
    .outline-btn {
        background-color: transparent !important;
        border: 1px solid #8d8e8f;
        color: #8d8e8f;
        border-radius: 50px;
        line-height: 10px;
        height: 36px;
    }
    .outline-btn:focus {
        outline: none; 
        box-shadow: none;
    }
    .refresh-btn{
        color: white;
        background-color: #14C6DE;
        border-radius: 50px;
        line-height: 10px;
        height: 36px;
    }
    .refresh-btn:focus {
        outline: none; 
        box-shadow: none;
    }
</style>